import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogComponent } from './blog/blog.component';
import { CartComponent } from './shopping/cart/cart.component';
import { ContactComponent } from './contact/contact.component';
import { ProductDetailsComponent } from './shopping/product-details/product-details.component';
import { HomeComponent } from './home/home.component';
import { ProductComponent } from './shopping/product/product.component';
import { CheckoutFormComponent } from './shared/components/checkout-form/checkout-form.component';
import { LoginComponent } from './login/login.component';
import { PaymentsComponent } from './payments/payments.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { SurveyComponent } from './survey/survey.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { PreguntasFrecuentesComponent } from './preguntas-frecuentes/preguntas-frecuentes.component'; // Importa el componente
import { AccountComponent } from './account/account.component'; // Importa el componente
import { CouponComponent } from './coupon/coupon.component'; // Importa el componente
import { PlayerasComponent } from './playeras/playeras.component';
import { CamisasComponent } from './camisas/camisas.component';


//import {canActivate, redirectUnauthorizedTo} from '@angular/fire/auth-guard'

// const routes: Routes = [
//   {
//     path: '',
//     pathMatch: 'full',
//     redirectTo: '/login'
//   },
//   {
//     path: 'login',
//     component: LoginComponent
//   },
//   {
//     path: 'home',
//     component: HomeComponent,
//     ...canActivate(() => redirectUnauthorizedTo(['/login'])),
//     children: [
//       {
//         path: 'productos',
//         component: ProductComponent,
//         ...canActivate(() => redirectUnauthorizedTo(['/login']))
//       },
//     ]
//   },
// ];

const routes: Routes = [
  { path: '', redirectTo: '/product', pathMatch: 'full'},
  { path: 'login', component: LoginComponent },
  { path: 'TiendaClubAdventista', component: HomeComponent },
  { path: 'PlayerasPersonalizadas', component: PlayerasComponent },
  { path: 'CamisasPersonalizadas', component: CamisasComponent },
  { path: 'product', component: ProductComponent },
  { path: 'cart', component: CartComponent },
  { path: 'product/:id', component: ProductDetailsComponent },
  //{ path: 'blog', component: BlogComponent },
  //{ path: 'contact', component: ContactComponent },
  { path: 'secure-checkout', component: CheckoutFormComponent },
  { path: 'payments', component: PaymentsComponent },
  { path: 'pedidos', component: DashboardComponent },
  { path: 'order-details', component: OrderDetailsComponent },
  { path: 'ubicacion', component: GoogleMapComponent },
  { path: 'encuesta', component: SurveyComponent },
  { path: 'encuesta/:id', component: SurveyComponent },
  { path: 'quienes-somos', component: AboutUsComponent },
  { path: 'preguntas-frecuentes', component: PreguntasFrecuentesComponent },
  { path: 'cuenta', component: AccountComponent },
  { path: 'cupones', component: CouponComponent },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
